// The API's OAuth server (Better Auth mcp plugin) sends users here with a signed query string.
// We never interpret it beyond reading display values - the server re-verifies the signature.

export const getOAuthQuery = (search: string = window.location.search): string | null => {
    const params = new URLSearchParams(search)
    return params.has('sig') && params.has('client_id') ? params.toString() : null
}

// After signing in, return to the authorize endpoint: it re-validates the request against the new
// session and forwards to the consent page.
export const authorizeUrl = (oauthQuery: string) =>
    `${import.meta.env.VITE_API_URL}/api/auth/oauth2/authorize?${oauthQuery}`
